/**
 * @flow
 * @relayHash ec6461e783d55d8140a75d95cdd61e8f
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type HomeDirectoryQueryVariables = {||};
export type HomeDirectoryQueryResponse = {|
  +viewer: ?{|
    +id: string
  |}
|};
export type HomeDirectoryQuery = {|
  variables: HomeDirectoryQueryVariables,
  response: HomeDirectoryQueryResponse,
|};
*/


/*
query HomeDirectoryQuery {
  viewer {
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "viewer",
    "storageKey": null,
    "args": null,
    "concreteType": "Query",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "HomeDirectoryQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": (v0/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "HomeDirectoryQuery",
    "argumentDefinitions": [],
    "selections": (v0/*: any*/)
  },
  "params": {
    "operationKind": "query",
    "name": "HomeDirectoryQuery",
    "id": null,
    "text": "query HomeDirectoryQuery {\n  viewer {\n    id\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '5608091a8d0083314aa58e32454163ff';
module.exports = node;
